module.exports = __webpack_public_path__ + "img/dsc-5292.37f57060.jpg";